const dynamicFederation = async (scope, module) => {
  try {
   
    let container;
    let attempts = 0;
    const maxAttempts = 50;
    
    while (!container && attempts < maxAttempts) {
      container = window[scope];

      if (!container) {
        await new Promise(resolve => setTimeout(resolve, 100));
        attempts++;
      }
    }

    if (!container) {
      throw new Error(`Container "${scope}" not found`);
    }

    if (!container.__initialized) {
      await container.init(__webpack_share_scopes__.default);
      container.__initialized = true;
    }

    const factory = await container.get(module);
    
    if (!factory) {
      throw new Error(`Module "${module}" not found in container "${scope}"`);
    }

    const Module = factory();

    return Module;
  } catch (error) {
    throw error;
  }
};

export default dynamicFederation;